import { FUEL_CATEGORIES } from "./Fields/FieldConfig";

export const calcMassPercentages = (fuels) => {
    const total = fuels.reduce((sum, f) => {
        const qty = Number(
            f.metadata?.find(m => m.metaKey === "QUANTITY|MT")?.metaValue
        ) || 0;
        return sum + qty;
    }, 0);

    return fuels.map(f => {
        const qty = Number(
            f.metadata?.find(m => m.metaKey === "QUANTITY|MT")?.metaValue
        ) || 0;
        const hasMass = Number(qty) > 0;
        const percent = total > 0 && hasMass ? ((qty / total) * 100).toString() : "0";

        const metadata = [...(f.metadata || [])];
        const idx = metadata.findIndex(m => m.metaKey === "PERCENT|MASS");

        if (idx >= 0) {
            metadata[idx] = { ...metadata[idx], metaValue: percent };
        } else {
            metadata.push({ metaKey: "PERCENT|MASS", metaValue: percent });
        }

        return { ...f, metadata };
    });
};

export const calcEnergyPercentages = (childFuels) => {
    if (!childFuels || !childFuels.length) return childFuels;

    const energies = childFuels.map(f => {
        const percentMass =
            Number(f.metadata?.find(m => m.metaKey === "PERCENT|MASS")?.metaValue) || 0;

        const lcv =
            Number(f.metadata?.find(m => m.metaKey === "IMO|LCV")?.metaValue) || 0;

        return percentMass * lcv;
    });
    const totalEnergy = energies.reduce((a, b) => a + b, 0);

    return childFuels.map((f, i) => {
        const hasEnergy = Number(energies[i]) > 0;
        const percentEnergy =
            totalEnergy > 0 && hasEnergy
                ? ((energies[i] / totalEnergy) * 100).toString()
                : "0";
        const metadata = [...(f.metadata || [])];
        const idx = metadata.findIndex(m => m.metaKey === "PERCENT|ENERGY");

        if (idx >= 0) {
            metadata[idx] = { ...metadata[idx], metaValue: percentEnergy };
        } else {
            metadata.push({
                metaKey: "PERCENT|ENERGY",
                metaValue: percentEnergy
            });
        }

        return { ...f, metadata };
    });
};
export const calcLcvs = (childFuels) => {
    if (!childFuels?.length) return childFuels;

    return childFuels.map(f => {
        const energy = Number(
            f.metadata?.find(m => m.metaKey === "ENERGY|CONTENT|MJ")?.metaValue
        );

        const quantity = Number(
            f.metadata?.find(m => m.metaKey === "QUANTITY|MT")?.metaValue
        );

        const updatedMetadata = [...(f.metadata || [])];

        const setMeta = (key, value) => {
            const idx = updatedMetadata.findIndex(m => m.metaKey === key);
            if (idx >= 0) {
                updatedMetadata[idx] = { ...updatedMetadata[idx], metaValue: value };
            } else {
                updatedMetadata.push({ metaKey: key, metaValue: value });
            }
        };
        const removeMeta = (key) => {
            const idx = updatedMetadata.findIndex(m => m.metaKey === key);
            if (idx >= 0) {
                updatedMetadata.splice(idx, 1);
            }
        };
        if (f.categoryType === FUEL_CATEGORIES.BIOFUEL) {
            const fuelCode = f.fuelType?.split(".")[0];
			if (fuelCode === "ETHA") {
				if (energy && quantity && !isNaN(energy) && !isNaN(quantity)) {
					const lcv = (energy / (quantity * 1_000_000)).toString();
					setMeta("EU|LCV", lcv);
				} else {
					removeMeta("EU|LCV");
				}
			} else {
				if (energy && quantity) {
					const lcv = (energy / (quantity * 1_000_000)).toString();

					setMeta("EU|LCV", lcv);

					const existingImo = updatedMetadata.find((m) => m.metaKey === "IMO|LCV");
					    if (!existingImo) {
							setMeta("IMO|LCV", lcv);
						} else if (!existingImo.isOverWritten && existingImo.metaValue !== "") {
                            setMeta("IMO|LCV", lcv);
						}
                        const eValue = Number(
                        updatedMetadata.find(m => m.metaKey === "E|VALUE|GCO2EQ|MJ")?.metaValue
                        );

                       const fuelCode = f.fuelType?.split(".")[0];

                      // Don't calculate for Ethanol
                        
						const currentImoLcv = Number(updatedMetadata.find((m) => m.metaKey === "IMO|LCV")?.metaValue ?? lcv);
                        if (fuelCode !== "ETHA" && !isNaN(eValue) && !isNaN(Number(currentImoLcv))) {
                            const imoCfCo2 = (eValue * Number(currentImoLcv)).toString();
                            
                            const existingImoCf = updatedMetadata.find((m) => m.metaKey === "IMO|CF|CO2");
                            if (!existingImoCf) {
                                setMeta("IMO|CF|CO2", imoCfCo2);
                            } else if (!existingImoCf.isOverWritten && existingImoCf.metaValue !== "") {
                               setMeta("IMO|CF|CO2", imoCfCo2);
                            }
                        }
				} else {
					removeMeta("EU|LCV");
					removeMeta("IMO|LCV");
				}
                
			}
            
        }
        

        return { ...f, metadata: updatedMetadata };
    });
};


export const calcCo2Eq = (childFuels) => {
    if (!childFuels || !childFuels.length) return childFuels;

    return childFuels.map(f => {
        const classification = f.categoryType;
        if (!["Biofuel", "e-Fuel"].includes(classification)) return f;

        const eVal = Number(
            f.metadata?.find(m => m.metaKey === "E|VALUE|GCO2EQ|MJ")?.metaValue
        ) || 0;

        const euVal = Number(
            f.metadata?.find(m => m.metaKey === "EU|VALUE")?.metaValue
        ) || 0;

        const ef = Number(
            f.metadata?.find(m => m.metaKey === "FEU|EF|CO2")?.metaValue
        ) || 0;

        const lcv = Number(
            f.metadata?.find(m => m.metaKey === "EU|LCV")?.metaValue
        ) || 0;

        let co2eq = null;
        const metadata = [...(f.metadata || [])];
        const idx = metadata.findIndex(m => m.metaKey === "CO2EQ|WTT");

        if (classification === "e-Fuel") {
            //  New formula
    co2eq = (eVal - euVal).toString();
            
        } else {
            // Existing formula (Biofuel)
            if (eVal && lcv) {
                co2eq = (eVal - (ef / lcv)).toString();
            }
        }

        if (co2eq !== null) {
            if (idx >= 0) {
                metadata[idx] = { ...metadata[idx], metaValue: co2eq };
            } else {
                metadata.push({ metaKey: "CO2EQ|WTT", metaValue: co2eq });
            }
        } else {
            if (idx >= 0) {
                metadata.splice(idx, 1);
            }
        }

        return { ...f, metadata };
    });
};

export const calcParentCo2s = (childFuels) => {
    if (!childFuels || !childFuels.length) return {};

    let imo = 0;
    let uk = 0;
    let hasAnyValue = false;

    childFuels.forEach(f => {
        const cf = Number(f.metadata?.find(m => m.metaKey === "IMO|CF|CO2")?.metaValue) || 0;
        const ef = Number(f.metadata?.find(m => m.metaKey === "UKMRV|EF|CO2")?.metaValue) || 0;
        const energy = Number(f.metadata?.find(m => m.metaKey === "PERCENT|ENERGY")?.metaValue) || 0;
        const mass = Number(f.metadata?.find(m => m.metaKey === "PERCENT|MASS")?.metaValue) || 0;

        if (cf || ef || energy || mass) hasAnyValue = true;

        const weight1 = energy / 100;
        const weight2 = mass / 100;
        imo += weight1 * cf;
        uk += weight2 * ef;
    });
    if (!hasAnyValue) {
        return {
            "IMO|CF|CO2": "",
            "UKMRV|EF|CO2": ""
        };
    }

    return {
        "IMO|CF|CO2": imo ? imo.toString() : "",
        "UKMRV|EF|CO2": uk ? uk.toString() : ""
    };
};

export const calcParentMass = (childFuels) => {
    if (!childFuels || !childFuels.length) return {};

    let totalMass = 0;
    let hasAnyValue = false;

    childFuels.forEach(f => {
        const massMt = Number(f.metadata?.find(m => m.metaKey === "QUANTITY|MT")?.metaValue) || 0;

        if (massMt) hasAnyValue = true;

        totalMass += massMt;
    });

    if (!hasAnyValue) {
        return {
            "QUANTITY|MT": ""
        };
    }

    return {
        "QUANTITY|MT": totalMass ? totalMass.toString() : ""
    };
};